module.exports = __webpack_public_path__ + "img/youtui.b032a6cb.png";